import React from 'react';

import SignaturePad from '../SignaturePad';
import useSignature from '../../hooks/useSignature';
import {
	Overlay,
	ModalCard,
	ModalHeader,
	ModalTitle,
	ModalFooter,
} from './SignatureModal.styles';

function SignatureModal({ onClose }) {
	const {
		loading,
		canvasOptions,
		signatureOptions,
		getCanvasRef,
		textCanvasRef,
		save,
		clear,
		undo,
		onChangeSignatureType,
		onChangeSignatureText,
		handleKeyDown
	} = useSignature({ onAfterSave: onClose });

	return (
		<Overlay className="doca" onClick={onClose}>
			<ModalCard onClick={e => e.stopPropagation()}>
				<ModalHeader>
					<ModalTitle>Assinar documento</ModalTitle>
					<button className="doca-button doca-button--tertiary doca-button--small" onClick={onClose}>
						<i className="doca-icon doca-icon__xmark"></i>
					</button>
				</ModalHeader>

				<div className="doca-px-4 doca-py-6">
					<SignaturePad
						loading={loading}
						signatureType={signatureOptions.signature_type}
						signatureText={signatureOptions.signature_text}
						onChangeSignatureType={onChangeSignatureType}
						onChangeSignatureText={onChangeSignatureText}
						handleKeyDown={handleKeyDown}
						canvasOptions={canvasOptions}
						getCanvasRef={getCanvasRef}
						textCanvasRef={textCanvasRef}
						onClear={clear}
						onUndo={undo}
					/>
				</div>

				<ModalFooter className="doca-flex doca-justify-end doca-items-center doca-gap-4 doca-p-4">
					<button className="doca-button doca-button--primary" onClick={save}>
						Salvar assinatura
					</button>
				</ModalFooter>
			</ModalCard>
		</Overlay>
	);
}

export default SignatureModal;
